import { convertToMapById } from "../../../helpers/convertToMap";
import { convertToObjById, convertToObjectByField } from "../../../helpers/convertToObject";
import { 
  baseSales, 
  typeSales, 
  periods, 
  routes, 
  transferTypes 
} from "./selects";

export const CONTRACT_CONDITION_SELECTED = 'CONTRACT_CONDITION_SELECTED';
export const GET_CONTRACTS_CONDITIONS_DATA = 'GET_CONTRACTS_CONDITIONS_DATA';
export const GET_CONTRACTS_CONDITIONS = 'GET_CONTRACTS_CONDITIONS';
export const CREATE_CONTRACT_CONDITION = 'CREATE_CONTRACT_CONDITION';
export const MOD_CONTRACT_CONDITION = 'MOD_CONTRACT_CONDITION';
export const DELETE_CONTRACT_CONDITION = 'DELETE_CONTRACT_CONDITION';
export const RESET_CONTRACT_CONDITION_SELECTED = 'RESET_CONTRACT_CONDITION_SELECTED';
export const ADD_CONTRACT_CONDITION_MODE = 'ADD_CONTRACT_CONDITION_MODE';
export const EDIT_CONTRACT_CONDITION_MODE = 'EDIT_CONTRACT_CONDITION_MODE';
export const CHECK_ADD_CONTRACT_CONDITIONS_MODE_PERMIT = 'CHECK_ADD_CONTRACT_CONDITIONS_MODE_PERMIT';
export const DELETE_CONTRACT_CONDITION_MODE = 'DELETE_CONTRACT_CONDITION_MODE';
export const CLEAR_CONTRACTS_CONDITIONS = 'CLEAR_CONTRACTS_CONDITIONS';
export const CLEAR_ONLY_CONTRACTS_CONDITIONS = 'CLEAR_ONLY_CONTRACTS_CONDITIONS';
export const GET_FORM_SELECTS = 'GET_FORM_SELECTS'; 

const INITIAL_STATE = {
  contractConditionSelected: null,
  contractsConditionsObj: {},
  contractsConditionsArr: [],
  addContractCondition: true,
  addMode: false,
  deleteMode: false,

  //Form options
  employeeTypes: [],
  branchOffices: [],
  pieceworks: [],
  seasons: [],
  tabulators: [],
  customerTypes: [],
  futures: [],
  employeeTypesObj: {},
  branchOfficesObj: {},
  pieceworksObj: {},
  seasonsObj: {},
  tabulatorsObj: {},
  customerTypesObj: {},
  futuresObj: {},

};

const findNames = ( payload, state ) => {
  return {
    baseSaleTbl: baseSales[payload.baseSale], 
    typeSaleTbl: typeSales[payload.typeSale], 
    periodTbl: periods[payload.period], 
    routeTbl: routes[payload.route], 
    transferTypeTbl: transferTypes[payload.transfers], 
    employeeTypeTbl: state.employeeTypesObj[payload.employeeType],
    branchOfficeTbl: state.branchOfficesObj[payload.branchOffice],
    pieceworkTbl: state.pieceworksObj[payload.piecework],
    seasonTbl: state.seasonsObj[payload.season],
    tabulatorTbl: state.tabulatorsObj[payload.tabulator],
    customerTypeTbl: state.customerTypesObj[payload.customerType],
    futureTbl: state.futuresObj[payload.future],
  };
};

export const contractsConditionsCatalogReducer = (state = INITIAL_STATE, { type, payload }) => {

  switch (type) {

    case ADD_CONTRACT_CONDITION_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      };

    case EDIT_CONTRACT_CONDITION_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      };

    case DELETE_CONTRACT_CONDITION_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      };
    
    case CHECK_ADD_CONTRACT_CONDITIONS_MODE_PERMIT:
      return {
        ...state,
        addContractCondition: payload,
      };

    case GET_CONTRACTS_CONDITIONS_DATA:
      const { employee_type, branch_office, piecework, season, tabulators, customerTypes, futures } = payload;
      return {
        ...state,
        employeeTypes: employee_type,
        branchOffices: branch_office,
        pieceworks: piecework,
        seasons: season,
        tabulators: tabulators,
        customerTypes: customerTypes,
        futures: futures,
        employeeTypesObj: convertToObjectByField(employee_type, "label" ,"value"),
        branchOfficesObj: convertToObjectByField(branch_office, "label" ,"value"),
        pieceworksObj: convertToObjectByField(piecework, "label" ,"value"),
        seasonsObj: convertToObjectByField(season, "label" ,"value"),
        tabulatorsObj: convertToObjectByField(tabulators, "label" ,"value"),
        customerTypesObj: convertToObjectByField(customerTypes, "label" ,"value"),
        futuresObj: convertToObjectByField(futures, "label" ,"value"),
      };

    case GET_CONTRACTS_CONDITIONS:
      const filteredContracts = payload
        .map(condition => {
          return {
            ...condition,
            ...findNames(condition, state)
          }});
      const listContracts = convertToObjById(filteredContracts);
      return {
        ...state,
        contractsConditionsObj: listContracts,
        contractsConditionsArr: filteredContracts
      };

    case CONTRACT_CONDITION_SELECTED:
      return {
        ...state,
        contractConditionSelected: payload && state.contractsConditionsObj[payload]
      };

    case RESET_CONTRACT_CONDITION_SELECTED:
      return {
        ...state,
        contractConditionSelected: null
      };

    case CREATE_CONTRACT_CONDITION:
      const newContractCondition = {
        ...payload[0],
        ...findNames(payload[0], state)
      };
      const addingContractCondition = [newContractCondition, ...state.contractsConditionsArr];
      const newContractsConditions = convertToObjById(addingContractCondition);
      return {
        ...state,
        contractsConditionsObj: newContractsConditions,
        contractsConditionsArr: addingContractCondition
      };

    case MOD_CONTRACT_CONDITION:
      const editedContractsConditions = {
        ...state.contractsConditionsObj,
        [payload.id]: {
          ...state.contractsConditionsObj[payload.id],
          ...payload,
          ...findNames(payload, state)
        },
      };
      return {
        ...state,
        contractsConditionsObj: editedContractsConditions,
        contractsConditionsArr: convertToMapById(editedContractsConditions)
      };

    case DELETE_CONTRACT_CONDITION:
      const dataArray = convertToMapById(state.contractsConditionsObj).filter(contract => contract.id !== payload);
      return {
        ...state,
        contractsConditionsObj: convertToObjById(dataArray),
        contractsConditionsArr: dataArray
      };

    case CLEAR_ONLY_CONTRACTS_CONDITIONS:
      return {
        ...state,
        contractConditionSelected: null,
        contractsConditionsObj: {},
        contractsConditionsArr: [],
        addContractCondition: true,
        addMode: false,
        deleteMode: false,
      };

    case CLEAR_CONTRACTS_CONDITIONS:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    default :
      return state;
  }
};